import { render, staticRenderFns } from "./TaxCategoryListFilter.vue?vue&type=template&id=389798a2&"
import script from "./TaxCategoryListFilter.vue?vue&type=script&lang=js&"
export * from "./TaxCategoryListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports